export default __webpack_public_path__ + "static/media/Home_IMG-Civil-02.fa38a08c.png";